
import { defineComponent } from 'vue';
import Incentives from '../Incentives/Incentives.vue';
import LeftContentContainer from './LeftContentContainer.class';

export default defineComponent({
	components: {
		Incentives,
	},
	emits: ['notNow', 'accept' ],
	setup: (_, { emit }) => {
		const component = new LeftContentContainer(emit);
		return {
			notNow: component.notNow.bind(component),
			accept: component.accept.bind(component),
			openNotificationSettings: component.openNotificationSettings.bind(component),
		};
		return {};
	},
});
